import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UnitDetail from './pages/UnitDetail';

function App() {
  const [auth, setAuth] = useState(() => {
    try {
      const token = localStorage.getItem('token');
      const raw   = localStorage.getItem('user');
      if (!token) return null;
      // raw can be null, or stale garbage left by an older build. Never let
      // JSON.parse throw here — it would white-screen the app on boot.
      return { token, user: raw ? JSON.parse(raw) : {} };
    } catch {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return null;
    }
  });

  const login = (data) => {
    // This shape must match what POST /auth/login returns in api/index.js.
    const user = {
      name:         data.name,
      username:     data.username,
      role:         data.role,
      company_id:   data.company_id,
      company_name: data.company_name,
      company_slug: data.company_slug,
    };
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(user));
    setAuth({ token: data.token, user });
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setAuth(null);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={
          auth ? <Navigate to="/" /> : <Login onLogin={login} />
        } />
        <Route path="/" element={
          auth ? <Dashboard auth={auth} onLogout={logout} /> : <Navigate to="/login" />
        } />
        <Route path="/unit/:unitId" element={
          auth ? <UnitDetail auth={auth} onLogout={logout} /> : <Navigate to="/login" />
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
